import { logger } from "services/Logger";

const LOG_PREFIX = "[location]";

export const getLocationString = async (
  latitude: number,
  longitude: number 
): Promise<string> => {
  try {
    if (typeof window !== 'undefined' && 'geolocation' in navigator) {
      return `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
    }
    return `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
  } catch (error) {
    logger.error(
      `${LOG_PREFIX} getLocationString - Failed to get location string`,
      { error }
    );
    return `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
  }
};